import React from "react";
import { SectionHeader, SectionContainer, SectionFooter } from ".";
import Reveal from "@kogk/react-reveal/Reveal";
import "animate.css/animate.compat.css";

export default class Section extends React.Component {
  state = {};

  static defaultProps = {
    selectMax: 1,
    onSubmit: () => {}
  };

  constructor(props) {
    super(props);
    const selected = (props.defaultSelected || []).reduce(
      (acc, cur) => ({ ...acc, [cur]: true }),
      {}
    );
    this.state = { ...selected };
  }

  onSelect = (id) => {
    this.setState((s) => {
      if (s[id]) return { [id]: false };
      const selected = Object.keys(s).filter((k) => s[k]);
      if (selected.length < this.props.selectMax) {
        return { [id]: true };
      }
    });
  };

  render() {
    const {
      defaultSelected, // unused
      loading, // unused
      complete,
      selectMax,
      sectionNumber,
      sectionName,
      sectionHeading,
      buttonClassName,
      onSubmit,
      submitMessage,
      children, // do not pass through to container element
      ...props
    } = this.props;

    const selectedIds = selectedIdsFromState(this.state);

    return (
      <SectionContainer {...props}>
        <Reveal effect="fadeIn slow">
          <SectionHeader
            number={sectionNumber}
            name={sectionName}
            heading={sectionHeading}
          />
        </Reveal>
        <div className="cards">{this.renderChildren()}</div>
        <Reveal effect="fadeIn delay-2s">
          <SectionFooter>
            <button
              disabled={complete || selectedIds.length !== selectMax}
              onClick={() => onSubmit(selectedIds)}
              className={[
                "button",
                "w-40",
                "transition-colors duration-200",
                buttonClassName || ""
              ].join(" ")}
            >
              Submit
            </button>
            {complete ? (
              <h4 className="h3 mt-8 mb-0">{submitMessage}</h4>
            ) : null}
          </SectionFooter>
        </Reveal>
      </SectionContainer>
    );
  }

  renderChildren() {
    return React.Children.map(this.props.children, (child) => {
      const { props } = child;
      return React.cloneElement(child, {
        onChange: () => this.onSelect(props.id),
        selected: !!this.state[props.id],
        readOnly: this.props.complete
      });
    });
  }
}

function selectedIdsFromState(state) {
  return Object.keys(state).filter((k) => state[k]);
}
